import FieldEditor from "editor/FieldEditor";
import ContentAdminEditor from "content/adminEditors/ContentAdminEditor";
import Gallery from "gallery/Gallery";


class ContentAdminEditorGallery extends ContentAdminEditor {

    static get_name() {
        return 'Gallery';
    }

    getInputType() {
        return '4';
    }

    /**
     * @abstract
     * @return Array
     */
    getSettingsOptions() {
        return Gallery.get_profiles().then((profiles) => {
            return [
                {
                    name: 'slug',
                    label: 'Slug',
                    type: 'text'
                },
                {
                    name: 'profile',
                    label: 'Profile',
                    type: 'select',
                    options: profiles.map((profile) => {
                        return {
                            value: profile.id,
                            label: profile.name
                        }
                    })
                }
            ];
        })
    }
}

FieldEditor.register_editor('content/admin/gallery', ContentAdminEditorGallery);

export default ContentAdminEditorGallery;
